// extracted by mini-css-extract-plugin
export default {"advertDetailInfo":"c-h_fa","advertDetailInfo__headerWrapper":"c-h_fb"};